
                <ng-container *ngIf="trialUser == 0">
<p><strong>Hi {{ username }},</strong></p>
           
                <p>Just a quick note: your account’s ready whenever you are.</p>
           
                <p>Need help with a paper? Curious how the process works? I’m always happy to help — even if you’re just exploring.</p>
           
                <p>Warmly,<br>
                Sarah</p>
             <br>
            <hr style="width:100%; border:0; height:1px; background:rgba(0, 123, 255, 0.2);">
 
          <table cellpadding="0" cellspacing="0" width="100%" style="padding-top: 20px;">
                <tr>
                    <td width="100" align="left" valign="top" style="padding-right: 10px;">
                        <img src="https://backend.skyscrapersnow.com/images/sarah.png" alt="Sarah A." width="97" height="124" style="border-radius: 8px; display: block;">
                    </td>
                    <td align="left" valign="top" style="font-family: Arial, sans-serif; font-size: 14px; color: #333;">
                         <img src="https://backend.skyscrapersnow.com/images/sarah_sign.png" alt="Sarah A Signature" style="max-width: 82px;
    max-height: 34px;
    display: block;
    margin-bottom: 5px;">
                        <p style="font-weight: 500;
    font-size: 18px;
    color: #000000;

    text-align: left;
    margin: 0;">Sarah A.</p>
                        <p style="margin: 7px 0;
    color: #767E8C;
    font-size: 13px;
    text-align: left;">Student Support Specialist</p>
                        <table cellpadding="0" cellspacing="0" border="0">
                            <tr>
                                <td valign="middle" style="padding: 0px;">
                                    <img src="https://backend.skyscrapersnow.com/images/globe.png" alt="Website" width="15" height="15" style="display: block;">
                                </td>
                                <td valign="middle" style="font-size: 13px;color: #767E8C; padding: 0px 0px 0px 5px;">
                                    <a href="https://' . $site_link_clean . '" style="color: #767E8C; text-decoration: none;">{{ sitename }}</a>
                                </td>
                            </tr>
                        </table>
                    </td>
                </tr>
            </table>
                </ng-container>
                <ng-container *ngIf="trialUser == 1">
                              <div class="preheader">
                        I can connect you with a real academic — no pressure.
                    </div>
                
                    <p>Hey {{ username }},</p>
                
                    <p>
                      Just checking in — looks like you started something on {{ sitename | formatSitename }} but didn’t finish.<br>
                      Totally normal. If you want, I can connect you with one of our expert writers to help complete, improve, or rewrite your draft. It’s custom-written, fast, and fully confidential.
                    </p>
                
                    <p>
                      Just reply with what you're working on — I’ll handle the rest.
                    </p>
                
                    <p>All the best,<br>
                    Kate</p>
                   <br>
                    <hr style="width:100%; border:0; height:1px; background:rgba(0, 123, 255, 0.2);">
        
                    <table cellpadding="0" cellspacing="0" width="100%" style="padding-top: 20px;">
                        <tr>
                            <td width="100" align="left" valign="top" style="padding-right: 10px;">
                                <img src="https://backend.skyscrapersnow.com/images/kate.png" alt="Kate A." width="97" height="124" style="border-radius: 8px; display: block;">
                            </td>
                            <td align="left" valign="top" style="font-family: Arial, sans-serif; font-size: 14px; color: #333;">
                                 <img src="https://backend.skyscrapersnow.com/images/kate_sign.png" alt="Kate A Signature" style="max-width: 97px; max-height:46px; display: block; margin-bottom: 9px;">
                                <p style="margin: 0; font-weight: 500; font-size: 18px; color:#000000;">Kate A.</p>
                                <p style="margin: 9px 0; color: #767E8C; font-size: 13px;">Student Support Specialist</p>
                                <table cellpadding="0" cellspacing="0" border="0">
                                    <tr>
                                        <td valign="middle" style="padding-right: 5px;">
                                            <img src="https://backend.skyscrapersnow.com/images/globe.png" alt="Website" width="15" height="15" style="display: block;">
                                        </td>
                                        <td valign="middle" style="font-size: 13px; color: #767E8C;">
                                            <a href="https://'.$SETTING['site_link'].'" style="color: #767E8C; text-decoration: none;">{{ sitename }}</a>
                                        </td>
                                    </tr>
                                </table>
                            </td>
                        </tr>
                    </table>
                </ng-container>